import React, { useState } from 'react';
import '../../css/about.css';

const DataDeletion = () => {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Opens a pre-filled email to support
    const subject = encodeURIComponent('Data Deletion Request');
    const body = encodeURIComponent(
      `Hello,\n\nI would like to request deletion of all personal data associated with my account.\n\nEmail: ${email}\n\nPlease confirm when this has been completed.\n\nThank you.`
    );
    window.location.href = `mailto:support@unsupervisedbias.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  return (
    <div className="about-page">
      <section className="about-section">
        <div className="container">
          <h1>Data Deletion Request</h1>

          <p>
            This page is provided in accordance with Meta Platform Terms for applications using the
            Instagram Graph API and Facebook Login.
          </p>

          <h2>What data we hold</h2>
          <p>
            If you have interacted with UnsupervisedBias or pdubfantasy.com through Facebook Login or
            Instagram, we may hold:
          </p>
          <ul>
            <li>Your name and email address (if provided during registration)</li>
            <li>A record of your authorization of our Meta application</li>
            <li>Any content you submitted through our platforms</li>
          </ul>
          <p>
            We do <strong>not</strong> retain Instagram post content, media, or engagement metrics
            belonging to users other than our own managed accounts.
          </p>

          <h2>How to request deletion</h2>
          <p>
            To request deletion of all personal data we hold, please use one of the following methods:
          </p>

          <h3>Option 1 — Email request</h3>
          <p>
            Send an email to{' '}
            <a href="mailto:support@unsupervisedbias.com" style={{ color: 'var(--pink)' }}>
              support@unsupervisedbias.com
            </a>{' '}
            with the subject line <strong>"Data Deletion Request"</strong> and include the email
            address associated with your account. We will process your request within 30 days and
            send a confirmation.
          </p>

          <h3>Option 2 — Quick request form</h3>
          {submitted ? (
            <div style={{
              background: 'rgba(0,200,83,0.1)',
              border: '1px solid rgba(0,200,83,0.3)',
              borderRadius: '8px',
              padding: '16px 20px',
              color: '#00c853',
              marginTop: '12px',
            }}>
              ✓ Your email client has been opened with a pre-filled request. Please send the email
              to complete your deletion request.
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ maxWidth: '420px', marginTop: '12px' }}>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', marginBottom: '6px', color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>
                  Your email address
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: 'rgba(255,255,255,0.07)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '8px',
                    color: '#fff',
                    fontSize: '0.9rem',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              <button
                type="submit"
                style={{
                  padding: '10px 24px',
                  background: 'var(--pink, #e94560)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                }}
              >
                Submit Deletion Request
              </button>
            </form>
          )}

          <h2 style={{ marginTop: '2rem' }}>Facebook app deauthorization</h2>
          <p>
            If you authorized our app through Facebook Login, you can also revoke access directly
            through Facebook:
          </p>
          <ol>
            <li>Go to <strong>Facebook Settings → Apps and Websites</strong></li>
            <li>Find <strong>"Pdub Fantasy API"</strong> in the list</li>
            <li>Click <strong>Remove</strong></li>
          </ol>
          <p>
            Revoking access through Facebook will immediately revoke our ability to access your
            Facebook/Instagram data. We will also delete any associated data from our systems within
            30 days of receiving notice of the deauthorization.
          </p>

          <h2>Contact</h2>
          <p>
            For any questions about data deletion or our privacy practices, contact us at{' '}
            <a href="mailto:support@unsupervisedbias.com" style={{ color: 'var(--pink)' }}>
              support@unsupervisedbias.com
            </a>
            . We will respond within 30 days.
          </p>

          <p style={{ marginTop: '2rem', color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem' }}>
            Last updated: April 2026 · UnsupervisedBias, Washington, DC
          </p>
        </div>
      </section>
    </div>
  );
};

export default DataDeletion;
